export default __webpack_public_path__ + "static/media/bg-login.058d90b3.png";